module.exports = __webpack_public_path__ + "img/freesia.e156ef64.png";